// Mock data for Rent With Driver Torino

export const services = [
  {
    id: 1,
    title: "Trasferimenti Aeroportuali",
    description: "Servizio professionale da e per gli aeroporti di Malpensa, Linate e Bergamo. Puntualità garantita e massimo comfort.",
    icon: "Plane",
    image: "https://images.pexels.com/photos/4530180/pexels-photo-4530180.jpeg",
    features: ["Monitoraggio voli", "Meet & Greet", "Assistenza bagagli"]
  },
  {
    id: 2,
    title: "Servizi Aziendali",
    description: "Soluzioni di trasporto dedicate per meeting, eventi corporate e trasferte di lavoro. Discrezione e professionalità.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1530521954074-e64f6810b32d",
    features: ["Fatturazione elettronica", "Servizio continuativo", "Multi-destinazioni"]
  },
  {
    id: 3,
    title: "Cerimonie ed Eventi",
    description: "Rendete speciale il vostro giorno importante con il nostro servizio premium per matrimoni, anniversari e celebrazioni.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1698840059740-ba83e510733b",
    features: ["Auto decorata", "Servizio personalizzato", "Fotografo disponibile"]
  },
  {
    id: 4,
    title: "Tour nelle Langhe",
    description: "Esplorate le meraviglie delle Langhe con tour enogastronomici personalizzati. Relax e scoperta del territorio.",
    icon: "MapPin",
    image: "https://images.unsplash.com/photo-1645794225645-6fc366b25bbf",
    features: ["Itinerari personalizzati", "Cantine e ristoranti", "Guida turistica"]
  }
];

export const fleet = [
  {
    id: 1,
    model: "Mercedes Classe V",
    category: "Premium Van",
    passengers: "6-7",
    luggage: "8",
    features: ["Aria condizionata", "Wi-Fi", "Poltrone in pelle", "Bottled water"],
    image: "https://customer-assets.emergentagent.com/job_rent-with-driver-to/artifacts/j3o7xvag_IMG_20260117_131615_355.PNG",
    gallery: [
      "https://customer-assets.emergentagent.com/job_rent-with-driver-to/artifacts/j3o7xvag_IMG_20260117_131615_355.PNG",
      "https://customer-assets.emergentagent.com/job_rent-with-driver-to/artifacts/fvziq3eo_IMG_20260117_131603_609.PNG",
      "https://customer-assets.emergentagent.com/job_rent-with-driver-to/artifacts/iufgz25z_IMG_20260117_131603_515.PNG"
    ],
    color: "Nero"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marco Bianchi",
    role: "CEO, Tech Solutions",
    rating: 5,
    text: "Servizio impeccabile. Ho utilizzato Rent With Driver per diversi trasferimenti aziendali e non ho mai avuto problemi. Autista professionale e puntuale.",
    date: "Gennaio 2025"
  },
  {
    id: 2,
    name: "Laura Rossi",
    role: "Sposa",
    rating: 5,
    text: "Il nostro matrimonio è stato perfetto anche grazie al loro servizio. Mercedes impeccabile e autista gentilissimo. Consigliatissimo!",
    date: "Dicembre 2024"
  },
  {
    id: 3,
    name: "Giovanni Ferrari",
    role: "Business Traveler",
    rating: 5,
    text: "Utilizzo questo servizio per i miei trasferimenti da Malpensa a Torino. Sempre puntuale, comfortable e professionale. Top!",
    date: "Novembre 2024"
  },
  {
    id: 4,
    name: "Sofia Martini",
    role: "Cliente privata",
    rating: 5,
    text: "Abbiamo fatto un tour nelle Langhe meraviglioso. L'autista conosceva tutti i posti migliori. Esperienza da ripetere!",
    date: "Ottobre 2024"
  }
];

export const coverageAreas = [
  {
    id: 1,
    name: "Torino Centro",
    distance: "0 km",
    duration: "Base",
    type: "city"
  },
  {
    id: 2,
    name: "Aeroporto di Torino Caselle",
    distance: "16 km",
    duration: "20min",
    type: "airport"
  },
  {
    id: 3,
    name: "Langhe - Alba, Barolo, Barbaresco",
    distance: "60-80 km",
    duration: "1h",
    type: "tour"
  },
  {
    id: 4,
    name: "Sestriere",
    distance: "90 km",
    duration: "1h 30min",
    type: "mountain"
  },
  {
    id: 5,
    name: "Monginevro",
    distance: "95 km",
    duration: "1h 40min",
    type: "mountain"
  },
  {
    id: 6,
    name: "Cervinia",
    distance: "110 km",
    duration: "1h 45min",
    type: "mountain"
  },
  {
    id: 7,
    name: "Aeroporto di Malpensa",
    distance: "120 km",
    duration: "1h 30min",
    type: "airport"
  },
  {
    id: 8,
    name: "Aeroporto di Linate",
    distance: "140 km",
    duration: "1h 45min",
    type: "airport"
  },
  {
    id: 9,
    name: "Aeroporto di Bergamo Orio al Serio",
    distance: "190 km",
    duration: "2h 15min",
    type: "airport"
  }
];

export const whatsappNumber = "+393494624648";
export const formattedWhatsappNumber = "+39 349 462 4648";
export const companyName = "Rent With Driver Torino";
export const companyEmail = "rentwithdrivertorino@gmail.com";
